'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('fpx'),
    isFunction = _require.isFunction,
    validate = _require.validate;

var _require2 = require('./ques'),
    Que = _require2.Que;

var _require3 = require('./lifetime'),
    _deinit = _require3.deinit,
    isDeinitable = _require3.isDeinitable;

var _require4 = require('./subscription'),
    Subscription = _require4.Subscription;

var _require5 = require('./utils'),
    forceEach = _require5.forceEach,
    pull = _require5.pull,
    flushBy = _require5.flushBy;

var _require6 = require('./ref'),
    isRef = _require6.isRef;

/**
 * Interfaces
 */

exports.isObservable = isObservable;
function isObservable(value) {
  return isDeinitable(value) && isFunction(value.subscribe) && isFunction(value.unsubscribe);
}

exports.isObservableRef = isObservableRef;
function isObservableRef(value) {
  return isRef(value) && isObservable(value);
}

/**
 * Classes
 */

var Observable = function () {
  function Observable() {
    _classCallCheck(this, Observable);

    this.state = this.states.IDLE;
    this.subscriptions = [];
    this.que = new Que(triggerSubscriptions.bind(this));
  }

  // override in subclass


  Observable.prototype.onInit = function onInit() {};

  // override in subclass


  Observable.prototype.onDeinit = function onDeinit() {};

  Observable.prototype.subscribe = function subscribe(callback) {
    validate(isFunction, callback);

    if (this.state === this.states.IDLE) {
      this.state = this.states.ACTIVE;
      this.onInit();
    }

    var sub = new Subscription(this, callback);
    this.subscriptions.push(sub);
    return sub;
  };

  Observable.prototype.unsubscribe = function unsubscribe(sub) {
    pull(this.subscriptions, sub);
    if (this.state === this.states.ACTIVE && !this.subscriptions.length) {
      this.state = this.states.IDLE;
      this.onDeinit();
    }
  };

  Observable.prototype.trigger = function trigger() {
    this.que.push(arguments);
  };

  Observable.prototype.deinit = function deinit() {
    flushBy(this.subscriptions, _deinit);
  };

  return Observable;
}();

exports.Observable = Observable;

Observable.prototype.states = {
  IDLE: 'IDLE',
  ACTIVE: 'ACTIVE'
};

function triggerSubscriptions(args) {
  forceEach(this.subscriptions.slice(), triggerSubscription, args);
}

function triggerSubscription(subscription, args) {
  subscription.trigger.apply(subscription, args);
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/observable.js
// module id = 288
// module chunks = 118